import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import Footer from "@components/Homepage/Footer";
import PublicPage from "@components/PublicPage";
import DefaultMetadata from "@components/DefaultMetadata";

const useStyles = makeStyles((theme) => ({
  box: {
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "80vh",
  },
  root: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    // height: "80vh",
    width: "100%",
    paddingTop: 50,
    paddingBottom: 50,
  },
  card: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    justifyContent: "center",
  },
  cover: {
    borderRadius: "3px",
    width: "100%",
    height: "300px",
    position: "relative",
  },
}));

function AttributionsPage() {
  const classes = useStyles();

  return (
    <PublicPage>
      <DefaultMetadata title="EV Loader | Help Center" />

      <Box className={classes.box} paddingX={10}>
        <Typography component="h1" variant="h4" color="primary">
          Attributions
        </Typography>

        <div className={classes.root}>
          <p>EV Loader's Attributions :</p>
          <ul>
            <li>
              {" "}
              <a
                href="https://storyset.com/transport"
                target="_blank"
                className={classes.link}
              >
                Transport illustrations by Storyset
              </a>
            </li>
            <li>
              {" "}
              <a
                href="https://undraw.co/"
                target="_blank"
                className={classes.link}
              >
                unDraw
              </a>
            </li>
          </ul>
        </div>
      </Box>

      <Footer />
    </PublicPage>
  );
}

export default AttributionsPage;
